module.exports = __webpack_public_path__ + "img/quick_filters.f7979d23.png";